import Vue from 'vue';
import { assign } from 'lodash';
import * as api from 'api/api-persons';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = {};

const getters = {
  PersonDetails: state => id => state[id],
};

const actions = {
  GetPersonDetails({ commit }, params) {
    const type = params.type;
    const id = params.id;

    // Initial empty form
    if (id === -1) {
      commit(types.CLEAR_PERSON_DETAILS_STORE, { id });
    } else {
      commit(types.FETCH_PERSON_DETAILS_START, { id });
      api.getPersonDetails(
        type,
        id,
        (response) => {
          commit(types.RECEIVE_PERSON_DETAILS, { id, response });
        },
        (description, status, error) => {
          if (status === 404) {
            commit(types.FETCH_PERSON_DETAILS_NOT_FOUND, { id, error });
          } else {
            commit(types.FETCH_PERSON_DETAILS_ERROR, { id, error });
          }
        },
      );
    }
  },
  InitPersonDetails({ commit }, params) {
    const id = params.id;
    commit(types.CLEAR_PERSON_DETAILS_STORE, { id });
  },
  SavePersonDetails({ commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const payload = params.payload;
      commit(types.SAVE_PERSON_DETAILS_START, { id });
      console.log('save data', params);
      api.savePersonDetails(
        type,
        id,
        payload,
        (response) => {
          console.log('save');
          commit(types.SAVE_PERSON_DETAILS_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SAVE_PERSON_DETAILS_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SavePersonProfilePicture({ commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const file = params.file;
      commit(types.SAVE_PERSON_PROFILE_PICTURE_START, { id });
      console.log('save data', params);
      api.savePersonProfilePicture(
        type,
        id,
        file,
        (response) => {
          console.log('save');
          commit(types.SAVE_PERSON_PROFILE_PICTURE_DONE, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SAVE_PERSON_PROFILE_PICTURE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  RemovePersonProfilePicture({ commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;

      commit(types.REMOVE_PERSON_PROFILE_PICTURE_START, { id });
      api.removeProfilePicture(
        type,
        id,
        () => {
          commit(types.REMOVE_PERSON_PROFILE_PICTURE_DONE, { id });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.REMOVE_PERSON_PROFILE_PICTURE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  AddPerson({ commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const payload = params.payload;

      commit(types.ADD_PERSON_START, { id });
      console.log('add person data', params);
      api.addPerson(
        type,
        payload,
        (response) => {
          console.log('save');
          commit(types.ADD_PERSON_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.ADD_PERSON_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  DeletePerson({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;

      commit(types.DELETE_PERSON_START, { id });
      console.log('delete person', params);
      api.deletePerson(
        type,
        id,
        payload,
        () => {
          commit(types.DELETE_PERSON_SUCCESSFUL, { id });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.DELETE_PERSON_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SetPersonEvolutionConfigured({ commit }, params) {
    const id = params.id;
    const value = params.value;
    commit(types.SET_PERSON_EVOLUTION_CONFIGURED, { id, value });
  },
  SendPersonAccountActivationToken({ commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      commit(types.SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_START, { id });
      api.sendAccountActivationToken(
        type,
        id,
        (response) => {
          console.log('save');
          commit(types.SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SetPersonStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      const type = params.type;
      const id = params.id;
      const payload = params.payload;

      commit(types.SET_PERSON_STATUS_START, { id });
      api.setPersonStatus(
        type,
        id,
        payload,
        (response) => {
          console.log('save');
          commit(types.SET_PERSON_STATUS_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.SET_PERSON_STATUS_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearPersonDetails({ commit }, { id }) {
    commit(types.CLEAR_PERSON_DETAILS_STORE, { id });
  },
};

const mutations = {
  [types.FETCH_PERSON_DETAILS_START](state, { id }) {
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_PERSON_DETAILS_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.FETCH_PERSON_DETAILS_NOT_FOUND](state, { id }) {
    Vue.set(state, id, assign({}, neutralState, { notFound: true }));
  },
  [types.RECEIVE_PERSON_DETAILS](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },

  [types.CLEAR_PERSON_DETAILS_STORE](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },

  [types.SAVE_PERSON_DETAILS_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SAVE_PERSON_DETAILS_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SAVE_PERSON_DETAILS_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: response.data, meta: response.meta }));
  },

  [types.ADD_PERSON_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.ADD_PERSON_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: response.data, meta: response.meta }));
  },
  [types.ADD_PERSON_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },

  [types.DELETE_PERSON_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.DELETE_PERSON_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.DELETE_PERSON_SUCCESSFUL](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },

  [types.SAVE_PERSON_PROFILE_PICTURE_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SAVE_PERSON_PROFILE_PICTURE_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SAVE_PERSON_PROFILE_PICTURE_DONE](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true }));
    Vue.set(state[id].data, 'ProfilePicture', response.data);
  },

  [types.REMOVE_PERSON_PROFILE_PICTURE_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.REMOVE_PERSON_PROFILE_PICTURE_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.REMOVE_PERSON_PROFILE_PICTURE_DONE](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true }));
    Vue.set(state[id].data, 'ProfilePicture', null);
  },

  [types.SET_PERSON_EVOLUTION_CONFIGURED](state, { id, value }) {
    Vue.set(state, id, assign(state[id], neutralState));
    Vue.set(state[id].data, 'evolution_configured', value);
  },

  [types.SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SEND_PERSON_ACCOUNT_ACTIVATION_TOKEN_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: response.data, meta: response.meta }));
  },

  [types.SET_PERSON_STATUS_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SET_PERSON_STATUS_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SET_PERSON_STATUS_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: response.data, meta: response.meta }));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/persons/entities/person-details.js